export default __webpack_public_path__ + "7ecda2eafbe36abf2580796f120e38d4.png";